import React from 'react';

interface IProps {
  children?: React.ReactNode | React.ReactNode[];
}

export const ModalFooter = (props: IProps) => (
  <div className="rounded-b-md bg-lake-fog p-6" {...props} />
);
